import React from "react";

/**
 * Inline SVG icons, deliberately not FontAwesome.
 *
 * Keeping this folder dependency-free is what makes it extractable into its own
 * Vite bundle later without dragging the portal's icon library along.
 */

const base = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
};

/** Remi's mark: a four-point spark. Reads as "assistant" without being a robot. */
export function RemiMark({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M12 2.2l2.15 5.83a4 4 0 002.37 2.37L22.35 12l-5.83 2.15a4 4 0 00-2.37 2.37L12 22.35l-2.15-5.83a4 4 0 00-2.37-2.37L1.65 12l5.83-2.15a4 4 0 002.37-2.37L12 2.2z" />
      <circle cx="19.5" cy="4.5" r="1.6" opacity="0.75" />
      <circle cx="4.6" cy="18.8" r="1.15" opacity="0.55" />
    </svg>
  );
}

export function ChevronDownIcon({ size = 18 }) {
  return (
    <svg {...base} width={size} height={size}>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function CloseIcon({ size = 18 }) {
  return (
    <svg {...base} width={size} height={size}>
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

export function SendIcon({ size = 18 }) {
  return (
    <svg {...base} width={size} height={size}>
      <path d="M22 2L11 13" />
      <path d="M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
  );
}

export function StopIcon({ size = 16 }) {
  return (
    <svg {...base} width={size} height={size}>
      <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function ThumbUpIcon({ size = 15 }) {
  return (
    <svg {...base} width={size} height={size} strokeWidth={1.8}>
      <path d="M7 22V11l5-9a2.5 2.5 0 012.4 3.2L13.4 9H19a2 2 0 012 2.4l-1.5 8A2 2 0 0117.5 21H7z" />
      <path d="M7 11H3v11h4" />
    </svg>
  );
}

export function ThumbDownIcon({ size = 15 }) {
  return (
    <svg {...base} width={size} height={size} strokeWidth={1.8}>
      <path d="M17 2v11l-5 9a2.5 2.5 0 01-2.4-3.2L10.6 15H5a2 2 0 01-2-2.4l1.5-8A2 2 0 016.5 3H17z" />
      <path d="M17 13h4V2h-4" />
    </svg>
  );
}

export function AlertIcon({ size = 16 }) {
  return (
    <svg {...base} width={size} height={size}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v5M12 16.5h.01" />
    </svg>
  );
}
